import { useCallback, useState } from 'react'

import { meetingApi } from '../api'
import { MeetingAssistFeedbackValue } from '../model/meetingInterfaces'

const useAssistFeedback = (meetingId: string | null) => {
  const [feedbackById, setFeedbackById] = useState<Record<string, MeetingAssistFeedbackValue>>({})

  const submitFeedback = useCallback(
    async (assistId: string, value: MeetingAssistFeedbackValue) => {
      if (!meetingId) {
        return
      }
      let previousValue: MeetingAssistFeedbackValue | undefined
      setFeedbackById((prev) => {
        previousValue = prev[assistId]
        return { ...prev, [assistId]: value }
      })
      try {
        await meetingApi.submitAssistFeedback(meetingId, assistId, value)
      } catch (error) {
        setFeedbackById((prev) => {
          if (!previousValue) {
            const next = { ...prev }
            delete next[assistId]
            return next
          }
          return { ...prev, [assistId]: previousValue }
        })
      }
    },
    [meetingId],
  )

  return { feedbackById, submitFeedback }
}

export default useAssistFeedback
